import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { Button } from '@rmwc/button';
import '@rmwc/button/styles';
import { Elevation } from '@rmwc/elevation';
import '@rmwc/elevation/styles';
import './Hilfe.css';
import { useFlexionStore } from './Stores';
import { getText } from './Helpers';

function Hilfe(props) {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [text, settext] = useState(getText(Sprache));

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <>
      <div className='HelpTitle'>
        <p>{text.Hilfe.TitDesc}</p>
      </div>
      <div className='HelpContainer'>
        <div className='LeftPlaceholder' />
        <Elevation z={15} wrap>
          <div className='DBiegung'>
            <h3>{text.Hilfe.DB}</h3>
            <p className='HilfeBlock'>
              {text.Hilfe.DBDesc} <br /> <br />
              <b>{text.Hilfe.Proc}</b> <br />
              <span>{text.Hilfe.DBProc}</span>
              <b>{text.Hilfe.AddInfo}</b> <br />
              <span>{parse(text.Hilfe.DBAdd)}</span>
            </p>
            <Button
              onClick={() => {
                props.onMethodeChange('D');
              }}
              outlined
              className='HilfeButton'
            >
              {text.Hilfe.DBButton}
            </Button>
          </div>
        </Elevation>
        <Elevation z={15} wrap>
          <div className='Vorsel'>
            <h3>{text.Hilfe.Pre}</h3>
            <p className='HilfeBlock'>
              {text.Hilfe.PreDesc} <br /> <br />
              <b>{text.Hilfe.Proc}</b> <br />
              <span>{text.Hilfe.PreProc}</span>
              <b>{text.Hilfe.AddInfo}</b> <br />
              <span>{text.Hilfe.PreAdd}</span>
            </p>
            <Button
              onClick={() => {
                props.onMethodeChange('V');
              }}
              outlined
              className='HilfeButton'
            >
              {text.Hilfe.PreButton}
            </Button>
          </div>
        </Elevation>
        <Elevation z={15} wrap>
          <div className='MDruckp'>
            <h3>{text.Hilfe.Mult}</h3>
            <p className='HilfeBlock'>
              {text.Hilfe.MultDesc}
              <br /> <br />
              <b>{text.Hilfe.Proc}</b> <br />
              <span>{text.Hilfe.MultProc}</span>
              <b>{text.Hilfe.AddInfo}</b> <br />
              <span>{parse(text.Hilfe.MultAdd)}</span>
            </p>
            <Button
              onClick={() => {
                props.onMethodeChange('M');
              }}
              outlined
              className='HilfeButton'
            >
              {text.Hilfe.MultButton}
            </Button>
          </div>
        </Elevation>
        <div className='RightPlaceholder' />
      </div>
    </>
  );
}

export default Hilfe;
